import {Link} from 'react-router-dom';
import {ArrowUpRight} from 'lucide-react';
import {useTranslation} from 'react-i18next';

export const InvestLink = ({location}) => {
  const {i18n} = useTranslation();
  return <Link className={`guest-invest-link guest-invest-link-${location}`} to="/invest" data-testid={`${location}-invest`}>
    {i18n.language === 'hi' ? 'निवेश' : 'Invest'}<ArrowUpRight size={14}/>
  </Link>;
};